import { useState } from 'react';
import { api } from '../lib/api';
import { useMe } from '../lib/me';

const DISMISS_KEY = 'quicktl_verify_banner_dismissed';

export default function VerifyEmailBanner() {
  const { me } = useMe();
  const [dismissed, setDismissed] = useState(() => sessionStorage.getItem(DISMISS_KEY) === '1');
  const [status, setStatus] = useState<'idle' | 'sending' | 'sent' | 'error'>('idle');
  const [errorMessage, setErrorMessage] = useState('');

  if (!me || me.emailVerifiedAt || dismissed) return null;

  async function handleResend() {
    setStatus('sending');
    setErrorMessage('');
    try {
      await api.resendVerificationEmail();
      setStatus('sent');
    } catch (err: any) {
      setStatus('error');
      setErrorMessage(err?.body?.error ?? 'Failed to send verification email.');
    }
  }

  function handleDismiss() {
    sessionStorage.setItem(DISMISS_KEY, '1');
    setDismissed(true);
  }

  return (
    <div className="border-b border-amber-500/20 bg-amber-500/10 px-6 py-3">
      <div className="max-w-4xl mx-auto flex items-center justify-between gap-4 flex-wrap">
        <p className="text-sm text-amber-200">
          {status === 'sent'
            ? <>Verification email sent to <strong>{me.email}</strong>. Check your inbox.</>
            : status === 'error'
            ? <>Couldn't send verification email: {errorMessage}</>
            : <>Please verify your email address. We sent a verification link when you signed up.</>}
        </p>
        <div className="flex items-center gap-3">
          {status !== 'sent' && (
            <button
              onClick={handleResend}
              disabled={status === 'sending'}
              className="text-sm font-medium text-amber-200 hover:text-amber-100 underline disabled:opacity-50"
            >
              {status === 'sending' ? 'Sending…' : 'Resend email'}
            </button>
          )}
          <button
            onClick={handleDismiss}
            aria-label="Dismiss"
            className="text-amber-200/60 hover:text-amber-200 text-lg leading-none"
          >
            ×
          </button>
        </div>
      </div>
    </div>
  );
}
